import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Section from './Section';
import { office } from '../../data/profile';

// Mapa de OpenStreetMap embebido: gratuito y sin API key
export default function OfficeMap() {
    const d = 0.006;
    const bbox = [office.lng - d, office.lat - d / 1.6, office.lng + d, office.lat + d / 1.6].join(',');
    const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${office.lat},${office.lng}`;
    const gmaps = `https://www.google.com/maps/search/?api=1&query=${office.lat},${office.lng}`;

    return (
        <Section id="ubicacion" eyebrow="Dónde encontrarme" title="Ubicación">
            <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
                <Box component="iframe" title="Mapa de la oficina" src={src} loading="lazy"
                    sx={{ display: 'block', width: '100%', height: { xs: 320, md: 440 }, border: 0 }} />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}
                    justifyContent="space-between" sx={{ p: 3 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                        <PlaceOutlinedIcon color="primary" />
                        <Box>
                            <Typography sx={{ fontWeight: 700 }}>{office.name}</Typography>
                            <Typography color="text.secondary">{office.address}</Typography>
                        </Box>
                    </Stack>
                    <Button variant="outlined" href={gmaps} target="_blank" rel="noopener" endIcon={<OpenInNewIcon />}>
                        Cómo llegar
                    </Button>
                </Stack>
            </Paper>
        </Section>
    );
}
